<div class="sr-only" aria-live="assertive">
  {{ ariaLiveText() }}
</div>
